import { render, staticRenderFns } from "./logicsetedit.vue?vue&type=template&id=2357b712&"
import script from "./logicsetedit.vue?vue&type=script&lang=js&"
export * from "./logicsetedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports